( function ( _s ) {
	const toggleDisableAttr = ( _filters, disable ) => {
		_filters.find( 'select' ).each( select => {
			_s( `.ss-content[data-id="${ select.getAttribute( 'data-id' ) }"]` ).attr(
				'disabled',
				disable
			);
		} );
	};

	/**
	 * Add default values on empty filters if applicable
	 * @param {Object} _filters
	 * @param {Object} filtersConfig - Configuration object for filters.
	 */
	const checkEmptyValues = ( _filters, filtersConfig ) => {
		for ( const [ key, value ] of Object.entries( filtersConfig ) ) {
			if ( _filters.find( `[name="${ key }"][data-default-value]` ).length && value === '' ) {
				const dataDefaultValue = _filters
					.find( `[name="${ key }"]` )
					.attr( 'data-default-value' );
				let parsedDataDefaultValue = ( () => {
					try {
						return JSON.parse( dataDefaultValue );
					} catch {
						return dataDefaultValue;
					}
				} )();

				if ( typeof parsedDataDefaultValue === 'object' ) {
					parsedDataDefaultValue = parsedDataDefaultValue.filter( n => n ).join( ',' );
				}

				filtersConfig[ key ] = parsedDataDefaultValue;
			}
		}

		return filtersConfig;
	};

	_s.fn.cardGridWithFilters = function () {
		return this.each( el => {
			const _self = _s( el );
			const _filters = _self.find( '.card-grid-filters' );
			const _cardContainers = _self.find( '.cards-container' );
			let filtersConfig = {};

			_filters.on(
				'fr:filters-changed',
				window.debounce( e => {
					filtersConfig = { ...filtersConfig, ...e.detail.params };

					filtersConfig = checkEmptyValues( _self, filtersConfig );

					_cardContainers.trigger( 'fr:do-ajax', { config: filtersConfig } );
				}, 100 )
			);

			_cardContainers.on( 'fr:ajax-started', () => {
				//Nothing to do right now here but it might be helpful.
				//For example add a class to the _filters so that all inputs are disabled while the ajax runs
				_filters.addClass( 'disabled-inputs' );
				toggleDisableAttr( _filters, true );
			} );

			_cardContainers.on( 'fr:ajax-ended', () => {
				_filters.removeClass( 'disabled-inputs' );
				toggleDisableAttr( _filters, false );
			} );

			_cardContainers.on( 'fr:cards-added', () => {
				//call the text clamping functionality on cards
				_s( window ).trigger( 'fr:initialize-shave', {
					callback: () => {
						_s( '.card' ).cardInit();
					},
				} );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.card-grid-with-filters-module' ).cardGridWithFilters();
	} );
} )( window._s );
